import { useState } from 'react';

export function useDebounceFn() {
  const [intervalId, setIntervalId] = useState(null);
  return (func, wait) => {
    if (intervalId) clearTimeout(intervalId);
    setIntervalId(setTimeout(func, wait));
  };
}
